import { Link } from "react-router-dom";
import { getAvatarChar } from "lib/utils/getAvatarChar";
import { formatKoreanDateTime } from "lib/utils/koreanDateTime";

export default function AdminActivityCard({ activities = [], moreTo }) {
  return (
    <div className="card activityCard">
      <div className="cardHeader">
        <h3>최근 활동</h3>
        {moreTo ? (
          <Link className="moreBtn" to={moreTo}>
            더보기
          </Link>
        ) : null}
      </div>

      <ul className="activityList">
        {activities.map((a, idx) => (
          <li
            key={`${a.user_name ?? "user"}-${a.log_created_at ?? "time"}-${idx}`}
            className="activityItem"
          >
            <div className="avatar">{getAvatarChar(a.user_name)}</div>

            <div className="activityBody">
              <div className="row">
                <span className="user">{a.user_name ?? "-"}</span>
                <span className="time">
                  {formatKoreanDateTime(a.log_created_at, {
                    sourceTimeZone: "kst",
                    year: "numeric",
                  })}
                </span>
              </div>

              <div className="desc">
                <span className="action">{a.api_title ?? "-"}</span>
                <span className="dot">-</span>
                <span style={{ whiteSpace: "pre-line" }} className="detail">
                  {a.log_message ?? "-"}
                </span>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
